import React from 'react';
import { NavLink } from 'react-router-dom';
import { Home, Map, Briefcase, ArrowRight } from 'lucide-react';
import TekyuLogo from './TekyuLogo';
import { buildBootcampUrl } from './utils/leadCapture';
export default function Sidebar() {
  const itemClass = ({isActive}) => `flex items-center gap-3 rounded-xl px-4 py-3 ${isActive ? 'bg-green-400/15 text-green-300' : 'text-slate-200 hover:bg-slate-800'}`;
  return <aside className="hidden md:flex md:flex-col w-72 shrink-0 border-r border-slate-800 bg-slate-900 p-4">
    <NavLink to="/dashboard" className="flex items-center gap-3 py-5"><TekyuLogo className="h-10 w-auto" ariaLabel="Tekyu Logo" /><span className="font-bold text-white">Tekyu</span></NavLink>
    <p className="mb-6 text-sm text-slate-400">Free roadmaps, projects and progress tracking.</p>
    <nav aria-label="Learning navigation" className="space-y-1">
      <NavLink to="/dashboard" className={itemClass}><Home size={20} />Dashboard</NavLink>
      <NavLink to="/roles" className={itemClass}><Map size={20} />Career paths</NavLink>
      <NavLink to="/portal?tab=projects" className="flex items-center gap-3 rounded-xl px-4 py-3 text-slate-200 hover:bg-slate-800"><Briefcase size={20} />Projects</NavLink>
      <NavLink to="/portal?tab=roadmaps" className="flex items-center gap-3 rounded-xl px-4 py-3 text-slate-200 hover:bg-slate-800"><Map size={20} />Saved roadmaps</NavLink>
    </nav>
    <div className="mt-8 rounded-xl border border-green-400/20 bg-green-400/5 p-4">
      <h2 className="font-bold text-white">Want live teaching?</h2>
      <p className="my-3 text-sm text-slate-300">Explore Cyber Agoge’s separate DevSecOps and AI security bootcamp.</p>
      <a href={buildBootcampUrl({utmMedium:'sidebar',utmCampaign:'bootcamp'})} className="inline-flex items-center gap-2 text-green-400">Explore the bootcamp <ArrowRight size={16} /></a>
    </div>
  </aside>;
}
